// extracted by mini-css-extract-plugin
export default {"contactForm":"ContactForm_contactForm__QO2Fu","formGroup":"ContactForm_formGroup__g2-SL"};